import React, { useEffect, useRef, useState } from 'react';
import { motion, useInView, useReducedMotion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { INVESTOR_QUESTIONS, BRAND, DEMO_URL } from '../../data/dgpt';
import { CtaButton } from '../ui/CtaButton';
import { cn } from '../../src/lib/utils';
export function QuestionsSection() {
  const ref = useRef<HTMLDivElement>(null);
  const inView = useInView(ref, {
    once: true,
    margin: '-20% 0px'
  });
  const reduceMotion = useReducedMotion();
  const [shown, setShown] = useState(reduceMotion ? INVESTOR_QUESTIONS.length : 0);
  useEffect(() => {
    if (reduceMotion) {
      setShown(INVESTOR_QUESTIONS.length);
      return;
    }
    if (!inView || shown >= INVESTOR_QUESTIONS.length) return;
    const id = window.setTimeout(() => setShown(value => value + 1), shown === 0 ? 300 : 650);
    return () => window.clearTimeout(id);
  }, [inView, shown, reduceMotion]);
  const complete = shown >= INVESTOR_QUESTIONS.length;
  return <section aria-labelledby="questions-heading" className="relative overflow-hidden border-b border-hairline-soft bg-elevated" data-id="element-339" data-mp="1dn76sn19545x">
      <div className="relative mx-auto w-full max-w-[1320px] px-4 py-24 sm:px-6 lg:px-8 lg:py-32" data-id="element-340" data-mp="1in382eikehhs">
        <h2 id="questions-heading" className="sf-display max-w-5xl text-[40px] leading-[1] text-text-primary sm:text-[60px] lg:text-[84px]" data-id="element-341" data-mp="1nk208rio4edc">
          Investors Don&apos;t Need Another Chatbot.
          <br data-id="element-342" data-mp="1wljf66kcaa0g" />
          <em data-id="element-343" data-mp="1wjp2ffj81o7g">They Need Better Answers.</em>
        </h2>

        <div ref={ref} className="mt-14 grid gap-12 lg:grid-cols-[minmax(0,1.3fr)_minmax(0,0.7fr)] lg:items-end" data-id="element-344" data-mp="21jurqp20qymd">
          <ol className="flex flex-col gap-3" aria-label="Questions investment teams ask" data-id="element-345" data-mp="26c4oanxn2wxm">
            {INVESTOR_QUESTIONS.map((question, index) => {
            const visible = index < shown;
            const latest = index === shown - 1 && !complete;
            return <motion.li key={question} initial={false} animate={{
              opacity: visible ? 1 : 0.12,
              x: visible || reduceMotion ? 0 : -8
            }} transition={{
              duration: 0.45,
              ease: [0.22, 1, 0.36, 1]
            }} className="flex items-start gap-4 border-b border-hairline-soft pb-3" data-id="element-346" data-mp="2kcfedor4k7hq" data-mpi={index}>
                  <span className="mt-1.5 font-mono text-xs text-text-tertiary" data-id="element-347" data-mp="p7pin10w0hqq">
                    {String(index + 1).padStart(2, '0')}
                  </span>
                  <span className={cn('text-lg font-medium tracking-[-0.02em] sm:text-2xl', latest ? 'text-lime' : 'text-text-primary')} data-id="element-348" data-mp="13z85nis5zcjl">
                    {question}
                  </span>
                </motion.li>;
          })}
          </ol>

          <motion.div initial={false} animate={{
          opacity: complete ? 1 : 0.25,
          y: complete || reduceMotion ? 0 : 12
        }} transition={{
          duration: 0.6,
          ease: [0.22, 1, 0.36, 1]
        }} className="flex flex-col items-start gap-3 rounded-2xl border border-lime/30 bg-panel p-6 sm:p-8" data-id="element-349" data-mp="3epy9w7ojksmn">
            <p className="text-3xl font-semibold tracking-[-0.03em] text-text-primary" data-id="element-350" data-mp="1u8yuwg0emccl">{BRAND.product}</p>
            <p className="text-lg font-medium text-lime" data-id="element-351" data-mp="1khb8itipflhz">{BRAND.tagline}</p>
            <p className="text-xs uppercase tracking-[0.14em] text-text-secondary" data-id="element-352" data-mp="1kfi2ngfx15b1">{BRAND.category}</p>
            <CtaButton href={DEMO_URL} event="section_book_demo_click" size="lg" className="mt-4 w-full sm:w-auto" data-id="element-353" data-mp="16jmnnlon0ecx">
              Book a Demo
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-354" data-mp="xhdcctljogyh" />
            </CtaButton>
          </motion.div>
        </div>
      </div>
    </section>;
}